import { User } from '@winelivery-org/wl-client-sdk-js';
import moment from 'moment';
import logger from '../logger';

type EventDataValue = string | number | boolean | Date | null | undefined;
type EventData = Record<string, EventDataValue | EventDataValue[] | Record<string, EventDataValue>[]>;

let clevertapInstance: any = null;

export const init = async (user?: User) => {
  if (typeof window === 'undefined') return;

  const accountId = process.env.NEXT_PUBLIC_CLEVERTAP_ACCOUNT_ID;
  if (!accountId) {
    logger.error('CleverTap Account ID mancante');
    return;
  }

  try {
    const ct = (await import('clevertap-web-sdk')).default;
    clevertapInstance = ct;

    ct.init(accountId, 'eu1');

    if (process.env.NODE_ENV !== 'production') {
      ct.setLogLevel(3);
    }

    if (user) {
      saveUser(user);
    }

    // @ts-ignore
    window.clevertap = ct;
  } catch (err) {
    logger.error('Errore durante il caricamento di CleverTap:', err);
  }
};

export const saveUser = (user: User) => {
  if (!clevertapInstance) return;

  try {
    let city;
    // @ts-ignore
    if (user.city && user.city.name) {
      // @ts-ignore
      city = user.city.name;
    }

    const birthdate = user.birthdate ? moment(user.birthdate).toDate() : undefined;

    clevertapInstance.onUserLogin.push({
      "Site": {
        "Identity": user._id,
        "Name": `${user.name} ${user.lastname}`,
        "Email": user.email,
        "Strategy": user.strategy || '',
        "Group": user.group || '',
        "MarketingAgreed": user.marketingAgreed || false,
        "City": city,
        "Phone": user.phone || '',
        ...(birthdate && { "DOB": birthdate }),
      }
    });
  } catch (err) {
    logger.error(err);
  }
};

export const recordEvent = (event: string, args?: EventData): void => {
  if (!clevertapInstance) return;
  try {
    clevertapInstance.event.push(event, args);
  } catch (err) {
    logger.error(err);
  }
};

export const logoutUser = () => {
  if (!clevertapInstance || typeof window === 'undefined') return;
  try {
    clevertapInstance.clear();
  } catch (err) {
    logger.error('Errore durante il logout di CleverTap:', err);
  }
};
